export const SystemConfigurationModulesNames = {
  AccountingEntryTypes: "Accounting entry types",
  AccountingEntryStatuses: "Accounting entry statuses",
  AdministrativeProcessTypes: "Administrative process types",

  AlertLineClaimTypes: "Alert line claim types",
  AlertLineUrls: "Alert line Urls",
  AlertLineReportStatus: "Alert line report status",
  AlertLineSuggestedNotes: "Alert line suggested notes",
  ArchiveStructures: "Archive structures",
  AssetTypes: "Asset Types",
  AuditTypes: "Audit Types",
  AvailableLanguages: "Available languages",

  ClarificationStatuses: "Clarification Statuses",
  ClarificationTypes: "Clarification Types",
  CompanyAccountTypes: "Company Account Types",
  Countries: "Countries",
  Currencies: "Currencies",

  DigestFrequencies: "Digest frequencies",
  DocumentCategories: "Document Categories",
  DocumentTypes: "Document Types",
  DocumentRequestTypes: "Document Request Types",
  DynamicFieldDefinitions: "Dynamic Field Definitions",

  EmailTemplates: "Email Templates",
  EmployeeCostSectionTypes: "Employee cost section types",
  EmployeeDependentTypes: "Employee Dependent Types",
  EmployeeSurveyExplanationSuggestions: "Employee survey explanation suggestions",
  EmployeeSurveyItemTypes: "Employee survey item types",
  EventTypes: "Corp. Event Types",

  ExchangeRatesAndSrouces: "Exchange rates",
  ExpensesRevenueTypes: "Expenses & Revenue Types",

  GTNSourceTypes: "GTN Source types",

  FieldValueTypes: "Field Value Types",
  FileStorageLocations: "File Storage Locations",

  Legislations: "Legislations",
  LocationTypes: "Location types",
  MailInboxes: "Mail inboxes",
  NotificationSourceTypes: "Notification source types",

  PaymentTypes: "Payment Types",

  PayrollEntryTypes: "Payroll Entry Types",
  PayrollEntryStatuses: "Payroll Entry Statuses",

  PnLTypes: "PnL Types",
  PnLConfig: "PnL Config",
  PnLCalculation: "PnL Calculation",

  Skills: "Skills",

  TravelExpenseSuggestedAuditComment: "Travel expense suggested audit comment",
  TnAConfig: "TnA Config",
  TransactionStatuses: "Transaction Statuses",
  TransactionTypes: "Transaction Types",
  TravelExpenseTypes: "Travel Expense Types",
  TravelExpenseSuggestedNotes: "Travel expense suggested notes",

  WageTypes: "Wage Types",
  Widgets: "Widgets",
};
